import ApiService from "./ApiService";
import {
	CriteriaDomainGetResponse,
	CriteriaDomainOptionPostRequest,
	CriteriaDomainOptionPostResponse,
	CriteriaDomainOptionPutRequest,
	CriteriaDomainOptionPutResponse,
	CriteriaDomainRelationPostRequest,
	CriteriaDomainRelationPostResponse,
	CriteriaDomainRelationPutRequest,
	CriteriaDomainRelationPutResponse,
} from "src/entities/CriteriaDomainEntity";

export const criteriaDomainQueryKeys = {
	domains: (id: string) => ["criteria", id, "domains"] as const,
};

export default class CriteriaDomainService extends ApiService {
	public async getDomains(criteriaId: number) {
		return await this.request.get<CriteriaDomainGetResponse>(`/api/v1/criteria/domains`, {
			params: { CriteriaId: criteriaId },
		});
	}
	public async postDomainRelation(data: CriteriaDomainRelationPostRequest) {
		return await this.request.post<CriteriaDomainRelationPostResponse>(`/api/v1/criteria/domains/relations`, data);
	}
	public async putDomainRelation(data: CriteriaDomainRelationPutRequest) {
		return await this.request.put<CriteriaDomainRelationPutResponse>(`/api/v1/criteria/domains/relations`, data);
	}
	public async postDomainOption(data: CriteriaDomainOptionPostRequest) {
		return await this.request.post<CriteriaDomainOptionPostResponse>(`/api/v1/criteria/domains/options`, data);
	}
	public async putDomainOption(data: CriteriaDomainOptionPutRequest) {
		return await this.request.put<CriteriaDomainOptionPutResponse>(`/api/v1/criteria/domains/options`, data);
	}
	public async deleteDomain(criteriaDomainId: number) {
		return await this.request.delete(`/api/v1/criteria/domains/${criteriaDomainId}`);
	}
}
